export const defaultCapStrikeForm = {
  capMode: 0,
  capStrikesList: '4.5, 5, 5.5',
  capStrikesAtmBpsList: '50, 100, 150',
};
